import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss']
})
export class SearchDropdownComponent {
  @Input() dropdownOptions: { label: string; value: string }[] = [];
  @Input() label: string = 'Filtre por plano';

  @Output() onClose = new EventEmitter();
  @Output() onFilter = new EventEmitter<string>();

  searchValue: string = '';
  filtering: boolean = false;

  constructor() {}

  handleOnClose() {
    this.filtering = false;
    this.searchValue = '';
    this.onClose.emit();
  }

  handleOnFilter() {
    this.filtering = true;
    this.onFilter.emit(this.searchValue);
  }
}
